export type ShiftStatusFilter = {
  awaitingConfirmation: boolean;
  requestToCancel: boolean;
  readyForShift: boolean;
  activeShift: boolean;
  dispute: boolean;
  cancelled: boolean;
  shiftCompleted: boolean;
  rateShift: boolean;
  paid: boolean;
  unpaid: boolean;
};

export type ShiftListUiState = {
  shiftState: number;
  sortOrder: "desc" | "asc";
  viewOption: "List" | "Calendar";
  activeCalendarDate: string;
  acceptedShiftStatusFilter: ShiftStatusFilter;
  pastShiftStatusFilter: ShiftStatusFilter;
};

export type ShiftListRouteState = {
  background?: any;
  selectedPharmacyIndex?: any;
  shiftListUiState?: Partial<ShiftListUiState> | null;
};

export type ShiftListUiStateCarrier = {
  shiftListUiState?: unknown;
};

export const withShiftListUiState = (shiftListUiState?: unknown) =>
  typeof shiftListUiState === "undefined" ? undefined : { shiftListUiState };